module.exports = {
	"classes": [
		"gdpr-assessment-tool",
		"header-dark"
	],
	"title": "The GDPR Readiness Assessment by Auth0 and Cordery",
	"metas": {
		"description": "GDPR is Coming. Are You Ready? Take our GDPR Readiness Assessment to find out."
	},
	"opengraph": {
		"og:title": "The GDPR Readiness Assessment by Auth0 and Cordery",
		"og:description": "GDPR is Coming. Are You Ready? Take our GDPR Readiness Assessment to find out.",
		"og:url": "https://auth0.com/gdpr-assessment/",
		"og:image": "http://cdn.auth0.com/website/gdpr/gdpr_twitter_card.png",
		"og:image:secure_url": "https://cdn.auth0.com/website/gdpr/gdpr_twitter_card.png"
	},
	"twittercard": {
		"twitter:title": "The GDPR Readiness Assessment by Auth0 and Cordery",
		"twitter:description": "GDPR is Coming. Are You Ready? Take our GDPR Readiness Assessment to find out.",
		"twitter:image": [
			{
				"src": "https://cdn.auth0.com/website/gdpr/gdpr_twitter_card.png"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/gdpr-assessment-tool/data/metadata.json
// module id = 1387
// module chunks = 0